import React from "react";
import * as Styles from "../../../../../common-deprecated/styles/v2/lexus/custom/SelectPane";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { useCompareV2Selector } from "../../../redux/store";
import { CompareV2Label } from "../../../utils/labels";
import Icon from "../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { isRTL } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";
import type { ModelGradeBodyTypeIdsType } from "../../../../../common-deprecated/features/compare/utils/newCarCompareTypes";

type SubmodelPanelPropsType = {
    setSelectedCar: (car: ModelGradeBodyTypeIdsType) => void;
    selectedCar: ModelGradeBodyTypeIdsType;
    clearSelection: () => void;
};

const SubmodelPanel = (props: SubmodelPanelPropsType): JSX.Element => {
    const { selectedCar, setSelectedCar, clearSelection } = props;
    const availableCarsData = useCompareV2Selector((state) => state.newCarCompare.available);
    const subModels = availableCarsData.find((m) => m.modelId === selectedCar.model)?.subModels;
    const isRTLValue = useCompareV2Selector((state) => isRTL(state.commonSettings));

    return (
        <Styles.Panel>
            {selectedCar.model && (
                <Styles.Header onClick={clearSelection}>
                    <Styles.HeaderButton>
                        <IconWrapper>
                            <Icon variant={isRTLValue ? "arrowRight" : "arrowLeft"} />
                        </IconWrapper>
                    </Styles.HeaderButton>
                    <CompareV2Label label="compareSelectBack" />
                </Styles.Header>
            )}

            <Styles.PanelContent>
                <Styles.PanelScroll>
                    {subModels &&
                        subModels.map(({ subModelId, subModelName }) => (
                            <Styles.PanelItem
                                key={subModelId + subModelName}
                                selected={selectedCar.submodelId === subModelId}
                                onClick={() =>
                                    setSelectedCar({
                                        ...selectedCar,
                                        submodelId: subModelId,
                                    })
                                }
                            >
                                {subModelName.trim()}
                            </Styles.PanelItem>
                        ))}
                </Styles.PanelScroll>
            </Styles.PanelContent>
        </Styles.Panel>
    );
};

export default SubmodelPanel;
